import React from 'react';
import './index.scss';
const isEditPage = location.pathname === '/lowcode/edit';
const TableTopSummary = (props) => {
    const summary = isEditPage
        ? [
            {
                label: '汇总信息组件编辑页示例',
                value: '99999',
                valueType: 'number',
            },
            {
                label: '文档地址',
                value: 'https://alidocs.dingtalk.com/i/nodes/a9E05BDRVQRkezKGC1945qLyJ63zgkYA',
                valueFontSize: 12,
            },
        ]
        : props._getCurrentTableInfo()?.__tableExtra__?.summary || [];
    return (React.createElement("div", { className: 'table-top-summary' }, summary.map((item) => {
        const { label = '', valueFontSize = 16, valueColor = '#397ae8', value, valueType, unit, } = item;
        const formattedValue = valueType === 'number' ? parseFloat(value).toLocaleString() : value;
        return (React.createElement("div", { className: 'table-top-summary-item' },
            React.createElement("span", { className: 'table-top-summary-item-label' }, label || ''),
            React.createElement("span", { className: 'table-top-summary-item-value', style: {
                    fontSize: valueFontSize,
                    color: valueColor,
                } }, typeof value === 'undefined' ? '' : formattedValue),
            React.createElement("span", { className: 'table-top-summary-item-unit' }, unit || '')));
    })));
};
TableTopSummary.displayName = 'TableTopSummary';
export { TableTopSummary };
